/**
 * 可提交到版本分支的最小目标上下文。
 */
export interface CommitTargetContext {
  /** 目标仓库 ID。 */
  readonly repositoryId: bigint;
  /** 目标分支 ID。 */
  readonly branchId: bigint;
}

/**
 * 校验提交目标是否具备版本写入所需的仓库和分支上下文。
 *
 * @param target 待提交的目标上下文。
 * @param targetLabel 错误提示中使用的业务目标名称。
 */
export function assertCommitTargetContext(target: CommitTargetContext, targetLabel: string): void {
  if (target.repositoryId <= 0n) {
    throw new Error(`当前${targetLabel}节点缺少 repositoryId，无法提交`);
  }
  if (target.branchId <= 0n) {
    throw new Error(`当前${targetLabel}节点缺少 branchId，无法提交`);
  }
}

